require('../layout');
require("slick-carousel");

$("#buy-process").find('.slide').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    if (i > 9 & slick.slideCount > 9) {
        $(".slick-count .big").text("" + i);
    } else {
        $(".slick-count .big").text("0" + i);
    }
    $(".slick-count .small").text("/" + slick.slideCount);
}).slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    fade: false,
    prevArrow: $("#buy-process").find(".arrows .prev-arrow"),
    nextArrow: $("#buy-process").find(".arrows .next-arrow"),
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
            }
        }
    ]
})